(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 7);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Popup = __webpack_require__(1);

module.exports = function (options) {
  if (!options.targetUrl) {
    throw new Error('Свойство targetUrl не должно быть пустым.');
  }

  function getSelectionText() {
    try {
      var txt = null;
      if (window.getSelection) {
        txt = window.getSelection();
      } else {
        if (window.document.getSelection) {
          txt = window.document.getSelection();
        } else {
          txt = window.document.selection;
        }
      }
      if (txt != null) {
        var before = "";
        var text = null;
        var after = "";
        var rangeQuantityWords = void 0;
        var popup = void 0;
        var range = void 0;
        var rangeClone = void 0;
        var txtStr = void 0;

        if (txt.getRangeAt) {
          var r = txt.getRangeAt(0);
          text = r.toString();

          range = window.document.createRange();
          range.setStartBefore(getSelectedNodeParentElement(r.startContainer));
          range.setEnd(r.startContainer, r.startOffset);
          before = range.toString().split(' ').slice(-6).join(' ');

          rangeClone = r.cloneRange();
          rangeClone.setStart(r.endContainer, r.endOffset);
          rangeClone.setEndAfter(getSelectedNodeParentElement(r.endContainer));
          after = rangeClone.toString().split(' ', 6).join(' ');
        } else {
          if (txt.createRange) {
            var _range = void 0;
            var _rangeClone = void 0;
            var _r = txt.createRange();
            text = _r.text;
            _range = txt.createRange();
            _range.moveStart("character", -60);
            _range.moveEnd("character", -text.length);
            before = _range.text;

            _rangeClone = txt.createRange();
            _rangeClone.moveEnd("character", 60);
            _rangeClone.moveStart("character", text.length);
            after = _rangeClone.text;
          } else {
            text = "" + txt;
          }
        }

        txtStr = txt.toString();

        rangeQuantityWords = txtStr.split(' ').length;

        popup = new Popup(before, txtStr, after, options.targetUrl);

        if (rangeQuantityWords < 20) {
          popup.build();
        } else {
          popup.renderToMuchWords();
        }
      } else {
        return;
      }
    } catch (e) {
      return null;
    }
  }

  function getSelectedNodeParentElement(node) {
    for (var i = 0; i < 2; i++) {
      node = node.parentNode;
      var styles = window.getComputedStyle(node);
      if (styles.display !== 'inline') {
        return node;
      }
    }
    return node;
  }

  window.document.onkeydown = function (e) {
    var popup = document.querySelector('.js-erratum-popup');

    if (e.keyCode == 13 && e.ctrlKey && window.getSelection().toString().length > 0 && !popup) {
      getSelectionText();
    }
  };
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var popupTemplate = __webpack_require__(3);
var types = __webpack_require__(2);

var stripHtmlTags = function stripHtmlTags(str) {
  return str.replace(/<[^>]+>/g, '');
};

var Popup = function () {
  function Popup(textBefore, textRange, textAfter, targetUrl) {
    _classCallCheck(this, Popup);

    this.textBefore = textBefore;
    this.textRange = textRange;
    this.textAfter = textAfter;
    this.targetUrl = targetUrl;
    this.state = 'typo';
    this.popup = document.createElement('div');
    this.popup.classList.add('js-erratum-popup');
    document.body.appendChild(this.popup);
  }

  _createClass(Popup, [{
    key: 'build',
    value: function build() {
      this.renderFoundTypo();
    }
  }, {
    key: 'renderFoundTypo',
    value: function renderFoundTypo() {
      this.popup.innerHTML = popupTemplate({
        title: types[this.state].title,
        text: this.textBefore + '<span>' + this.textRange + '</span>' + this.textAfter,
        buttonTitle: types[this.state].buttonTitle,
        typo: true
      });

      this.closeTrigger();
      this.submitTrigger();
    }
  }, {
    key: 'renderToMuchWords',
    value: function renderToMuchWords() {
      this.state = 'tomuch';
      this.popup.innerHTML = popupTemplate({
        text: types[this.state].text,
        buttonTitle: types[this.state].buttonTitle,
        tomuch: true
      });

      this.closeTrigger();
    }
  }, {
    key: 'renderSuccess',
    value: function renderSuccess() {
      this.popup.innerHTML = popupTemplate({
        text: types[this.state].text,
        buttonTitle: types[this.state].buttonTitle,
        success: true
      });

      this.closeTrigger();
    }
  }, {
    key: 'submitTrigger',
    value: function submitTrigger() {
      this.buttonSubmit = this.popup.querySelector('.js-erratum-popup_btn__submit');
      this.buttonSubmit && this.buttonSubmit.addEventListener('click', this.submit.bind(this));
    }
  }, {
    key: 'submit',
    value: function submit(event) {
      var _this = this;

      event.preventDefault();
      this.commentBox = this.popup.querySelector('.js-erratum-popup_textarea').value;
      var xhr = new XMLHttpRequest();

      var userInput = encodeURIComponent(stripHtmlTags(this.textBefore + ' ' + this.textRange + ' ' + this.textAfter));
      var userComment = encodeURIComponent(this.commentBox);
      var body = 'url=' + window.location.href + '&body=' + userInput + '&comment=' + userComment;

      xhr.open('POST', this.targetUrl, true);

      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

      xhr.onload = function () {
        if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
          _this.changeState('success');
        } else {
          try {
            var response = JSON.parse(xhr.responseText);
            var errors = response.errors;
            var errorEl = _this.popup.querySelector('.js-erratum-popup_error');

            if (errors && errorEl) {
              var messages = Object.entries(errors).map(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    _ = _ref2[0],
                    message = _ref2[1];

                return '' + message;
              });

              errorEl.textContent = '\u041E\u0448\u0438\u0431\u043A\u0430: ' + messages.join('; ');
              errorEl.style.display = 'block';
            }
          } catch (e) {
            console.error('Ошибка парсинга ответа:', e);
          }
        }
      };

      xhr.onerror = function () {
        console.error('Ошибка отправки запроса');
      };

      xhr.send(body);
    }
  }, {
    key: 'changeState',
    value: function changeState(state) {
      this.state = state;
      this.renderSuccess();
    }
  }, {
    key: 'closeTrigger',
    value: function closeTrigger() {
      this.iconClose = this.popup.querySelector('.js-close');
      this.buttonClose = this.popup.querySelector('.js-erratum-popup_btn__close');

      this.iconClose && this.iconClose.addEventListener('click', this.destroy.bind(this));
      this.buttonClose && this.buttonClose.addEventListener('click', this.destroy.bind(this));
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.popup.parentElement.removeChild(this.popup);
    }
  }]);

  return Popup;
}();

module.exports = Popup;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  typo: {
    title: 'Нашли ошибку',
    buttonTitle: 'Отправить',
    typo: true
  },
  success: {
    text: 'Спасибо. Мы получили ваше сообщение, исправим<br/>в ближайшее время',
    buttonTitle: 'Продолжить чтение',
    success: true
  },
  tomuch: {
    text: 'Вы выбрали слишком большой объем текста',
    buttonTitle: 'Продолжить чтение',
    tomuch: true
  }
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(4);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (buttonTitle, success, text, title, tomuch, typo) {pug_html = pug_html + "\u003Cform class=\"erratum-popup js-form\"\u003E\u003Cdiv class=\"erratum-popup_close js-close\"\u003E\u003C\u002Fdiv\u003E";
if (typo) {
pug_html = pug_html + "\u003Cdiv class=\"erratum-popup_title\"\u003E" + (pug.escape(null == (pug_interp = title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
if (success) {
pug_html = pug_html + "\u003Cdiv class=\"erratum-popup_emoji\"\u003E\u003Csvg width=\"34px\" height=\"36px\" viewBox=\"0 0 34 50\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\"\u003E\u003Cg fill-rule=\"evenodd\" font-size=\"36\"\u003E\u003Cg transform=\"translate(-468.000000, -296.000000)\" fill=\"#32292F\"\u003E\u003Ctext\u003E\u003Ctspan x=\"467\" y=\"339\"\u003E👍\u003C\u002Ftspan\u003E\u003C\u002Ftext\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003C\u002Fsvg\u003E\u003C\u002Fdiv\u003E";
}
if (tomuch) {
pug_html = pug_html + "\u003Cdiv class=\"erratum-popup_emoji\"\u003E\u003Csvg width=\"36px\" height=\"36px\" viewBox=\"0 0 36 50\" xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\"\u003E\u003Cg fill-rule=\"evenodd\" font-size=\"36\"\u003E\u003Cg transform=\"translate(-467.000000, -296.000000)\" fill=\"#32292F\"\u003E\u003Ctext\u003E\u003Ctspan x=\"467\" y=\"339\"\u003E😳\u003C\u002Ftspan\u003E\u003C\u002Ftext\u003E\u003C\u002Fg\u003E\u003C\u002Fg\u003E\u003C\u002Fsvg\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["erratum-popup_text",typo ? 'erratum-popup_text--typo' : ''], [false,true]), false, true)) + "\u003E" + (null == (pug_interp = text) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
if (typo) {
pug_html = pug_html + "\u003Ctextarea class=\"erratum-popup_textarea js-erratum-popup_textarea\" placeholder=\"Если есть желание, напишите комментарий\"\u003E\u003C\u002Ftextarea\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"erratum-popup_error js-erratum-popup_error\"\u003E\u003C\u002Fdiv\u003E";
if (typo) {
pug_html = pug_html + "\u003Cbutton class=\"erratum-popup_btn js-erratum-popup_btn__submit\" type=\"submit\"\u003E" + (pug.escape(null == (pug_interp = buttonTitle) ? "" : pug_interp)) + "\u003C\u002Fbutton\u003E";
}
else
if (tomuch || success) {
pug_html = pug_html + "\u003Cdiv class=\"erratum-popup_btn js-erratum-popup_btn__close\"\u003E" + (pug.escape(null == (pug_interp = buttonTitle) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fform\u003E";}.call(this,"buttonTitle" in locals_for_with?locals_for_with.buttonTitle:typeof buttonTitle!=="undefined"?buttonTitle:undefined,"success" in locals_for_with?locals_for_with.success:typeof success!=="undefined"?success:undefined,"text" in locals_for_with?locals_for_with.text:typeof text!=="undefined"?text:undefined,"title" in locals_for_with?locals_for_with.title:typeof title!=="undefined"?title:undefined,"tomuch" in locals_for_with?locals_for_with.tomuch:typeof tomuch!=="undefined"?tomuch:undefined,"typo" in locals_for_with?locals_for_with.typo:typeof typo!=="undefined"?typo:undefined));;return pug_html;};
module.exports = template;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var pug_has_own_property = Object.prototype.hasOwnProperty;

/**
 * Merge two attribute objects giving precedence
 * to values in object `b`. Classes are special-cased
 * allowing for arrays and merging/joining appropriately
 * resulting in a string.
 *
 * @param {Object} a
 * @param {Object} b
 * @return {Object} a
 * @api private
 */

exports.merge = pug_merge;
function pug_merge(a, b) {
  if (arguments.length === 1) {
    var attrs = a[0];
    for (var i = 1; i < a.length; i++) {
      attrs = pug_merge(attrs, a[i]);
    }
    return attrs;
  }

  for (var key in b) {
    if (key === 'class') {
      var valA = a[key] || [];
      a[key] = (Array.isArray(valA) ? valA : [valA]).concat(b[key] || []);
    } else if (key === 'style') {
      var valA = pug_style(a[key]);
      var valB = pug_style(b[key]);
      a[key] = valA + valB;
    } else {
      a[key] = b[key];
    }
  }

  return a;
};

/**
 * Process array, object, or string as a string of classes delimited by a space.
 *
 * If `val` is an array, all members of it and its subarrays are counted as
 * classes. If `escaping` is an array, then whether or not the item in `val` is
 * escaped depends on the corresponding item in `escaping`. If `escaping` is
 * not an array, no escaping is done.
 *
 * If `val` is an object, all the keys whose value is truthy are counted as
 * classes. No escaping is done.
 *
 * If `val` is a string, it is counted as a class. No escaping is done.
 *
 * @param {(Array.<string>|Object.<string, boolean>|string)} val
 * @param {?Array.<string>} escaping
 * @return {String}
 */
exports.classes = pug_classes;
function pug_classes_array(val, escaping) {
  var classString = '', className, padding = '', escapeEnabled = Array.isArray(escaping);
  for (var i = 0; i < val.length; i++) {
    className = pug_classes(val[i]);
    if (!className) continue;
    escapeEnabled && escaping[i] && (className = pug_escape(className));
    classString = classString + padding + className;
    padding = ' ';
  }
  return classString;
}
function pug_classes_object(val) {
  var classString = '', padding = '';
  for (var key in val) {
    if (key && val[key] && pug_has_own_property.call(val, key)) {
      classString = classString + padding + key;
      padding = ' ';
    }
  }
  return classString;
}
function pug_classes(val, escaping) {
  if (Array.isArray(val)) {
    return pug_classes_array(val, escaping);
  } else if (val && typeof val === 'object') {
    return pug_classes_object(val);
  } else {
    return val || '';
  }
}

/**
 * Convert object or string to a string of CSS styles delimited by a semicolon.
 *
 * @param {(Object.<string, string>|string)} val
 * @return {String}
 */

exports.style = pug_style;
function pug_style(val) {
  if (!val) return '';
  if (typeof val === 'object') {
    var out = '';
    for (var style in val) {
      /* istanbul ignore else */
      if (pug_has_own_property.call(val, style)) {
        out = out + style + ':' + val[style] + ';';
      }
    }
    return out;
  } else {
    val += '';
    if (val[val.length - 1] !== ';') 
      return val + ';';
    return val;
  }
};

/**
 * Render the given attribute.
 *
 * @param {String} key
 * @param {String} val
 * @param {Boolean} escaped
 * @param {Boolean} terse
 * @return {String}
 */
exports.attr = pug_attr;
function pug_attr(key, val, escaped, terse) {
  if (val === false || val == null || !val && (key === 'class' || key === 'style')) {
    return '';
  }
  if (val === true) {
    return ' ' + (terse ? key : key + '="' + key + '"');
  }
  if (typeof val.toJSON === 'function') {
    val = val.toJSON();
  }
  if (typeof val !== 'string') {
    val = JSON.stringify(val);
    if (!escaped && val.indexOf('"') !== -1) {
      return ' ' + key + '=\'' + val.replace(/'/g, '&#39;') + '\'';
    }
  }
  if (escaped) val = pug_escape(val);
  return ' ' + key + '="' + val + '"';
};

/**
 * Render the given attributes object.
 *
 * @param {Object} obj
 * @param {Object} terse whether to use HTML5 terse boolean attributes
 * @return {String}
 */
exports.attrs = pug_attrs;
function pug_attrs(obj, terse){
  var attrs = '';

  for (var key in obj) {
    if (pug_has_own_property.call(obj, key)) {
      var val = obj[key];

      if ('class' === key) {
        val = pug_classes(val);
        attrs = pug_attr(key, val, false, terse) + attrs;
        continue;
      }
      if ('style' === key) {
        val = pug_style(val);
      }
      attrs += pug_attr(key, val, false, terse);
    }
  }

  return attrs;
};

/**
 * Escape the given string of `html`.
 *
 * @param {String} html
 * @return {String}
 * @api private
 */

var pug_match_html = /["&<>]/;
exports.escape = pug_escape;
function pug_escape(_html){
  var html = '' + _html;
  var regexResult = pug_match_html.exec(html);
  if (!regexResult) return _html;

  var result = '';
  var i, lastIndex, escape;
  for (i = regexResult.index, lastIndex = 0; i < html.length; i++) {
    switch (html.charCodeAt(i)) {
      case 34: escape = '&quot;'; break;
      case 38: escape = '&amp;'; break;
      case 60: escape = '&lt;'; break;
      case 62: escape = '&gt;'; break;
      default: continue;
    }
    if (lastIndex !== i) result += html.substring(lastIndex, i);
    lastIndex = i + 1;
    result += escape;
  }
  if (lastIndex !== i) return result + html.substring(lastIndex, i);
  else return result;
};

/**
 * Re-throw the given `err` in context to the
 * the pug in `filename` at the given `lineno`.
 *
 * @param {Error} err
 * @param {String} filename
 * @param {String} lineno
 * @param {String} str original source
 * @api private
 */

exports.rethrow = pug_rethrow;
function pug_rethrow(err, filename, lineno, str){
  if (!(err instanceof Error)) throw err;
  if ((typeof window != 'undefined' || !filename) && !str) {
    err.message += ' on line ' + lineno;
    throw err;
  }
  try {
    str = str || __webpack_require__(5).readFileSync(filename, 'utf8')
  } catch (ex) {
    pug_rethrow(err, null, lineno)
  }
  var context = 3
    , lines = str.split('\n')
    , start = Math.max(lineno - context, 0)
    , end = Math.min(lines.length, lineno + context);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? '  > ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'Pug') + ':' + lineno
    + '\n' + context + '\n\n' + err.message;
  throw err;
};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(0);

/***/ })
/******/ ]);
});
//# sourceMappingURL=core.js.map